// extracted by mini-css-extract-plugin
export default {"ExitModal__Content":"C_gZX3p31m7QXOOFxMRV","ExitModal__Body":"HL34bmk2cVBFt9bENURH","ExitModalButton":"WEFZmCVNTSUfyNY2x9dX"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ExitModal__Content\":\"C_gZX3p31m7QXOOFxMRV\",\"ExitModal__Body\":\"HL34bmk2cVBFt9bENURH\",\"ExitModalButton\":\"WEFZmCVNTSUfyNY2x9dX\"}";
        // 1786025678838
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  